var map = {
	"./azishSausages": 6549,
	"./azishSausages.js": 6549,
	"./berryCake": 1500,
	"./berryCake.js": 1500,
	"./bluebarJam": 4161,
	"./bluebarJam.js": 4161,
	"./candiedFruit": 1040,
	"./candiedFruit.js": 1040,
	"./chickenAndFriedTenem": 3645,
	"./chickenAndFriedTenem.js": 3645,
	"./chickenAndMethiFruit": 8991,
	"./chickenAndMethiFruit.js": 8991,
	"./chouta": 7822,
	"./chouta.js": 7822,
	"./clemabread": 5872,
	"./clemabread.js": 5872,
	"./coconutCustard": 3383,
	"./coconutCustard.js": 3383,
	"./crabCurry": 4401,
	"./crabCurry.js": 4401,
	"./cremlingCakes": 4664,
	"./cremlingCakes.js": 4664,
	"./dinnerRolls": 3800,
	"./dinnerRolls.js": 3800,
	"./example": 5686,
	"./example.js": 5686,
	"./fishSoup": 4675,
	"./fishSoup.js": 4675,
	"./fishStew": 7143,
	"./fishStew.js": 7143,
	"./fluffyPancakes": 9570,
	"./fluffyPancakes.js": 9570,
	"./fruitSoup": 7477,
	"./fruitSoup.js": 7477,
	"./fruitedRice": 7746,
	"./fruitedRice.js": 7746,
	"./frybread": 2813,
	"./frybread.js": 2813,
	"./ingoTea": 7745,
	"./ingoTea.js": 7745,
	"./kuma": 6980,
	"./kuma.js": 6980,
	"./lavisAndCrab": 1600,
	"./lavisAndCrab.js": 1600,
	"./lavisCurry": 2668,
	"./lavisCurry.js": 2668,
	"./lavisFlatbread": 7468,
	"./lavisFlatbread.js": 7468,
	"./lavisFlatbreadPocket": 7206,
	"./lavisFlatbreadPocket.js": 7206,
	"./lavisPastrySquares": 4140,
	"./lavisPastrySquares.js": 4140,
	"./mashedSweetPotatoes": 6655,
	"./mashedSweetPotatoes.js": 6655,
	"./misirWat": 1174,
	"./misirWat.js": 1174,
	"./nutsAndHoneyPastry": 2207,
	"./nutsAndHoneyPastry.js": 2207,
	"./porkBroth": 7319,
	"./porkBroth.js": 7319,
	"./porkSkewers": 1704,
	"./porkSkewers.js": 1704,
	"./redPorkCurry": 6166,
	"./redPorkCurry.js": 6166,
	"./rocksStew": 2701,
	"./rocksStew.js": 2701,
	"./seededPancakes": 3086,
	"./seededPancakes.js": 3086,
	"./shiki": 7662,
	"./shiki.js": 7662,
	"./simberriesAndCreamPastry": 603,
	"./simberriesAndCreamPastry.js": 603,
	"./sodaBiscuits": 7543,
	"./sodaBiscuits.js": 7543,
	"./stagmAndTallew": 3570,
	"./stagmAndTallew.js": 3570,
	"./steamedStrannaHaspers": 8046,
	"./steamedStrannaHaspers.js": 8046,
	"./strawberryJam": 831,
	"./strawberryJam.js": 831,
	"./sugaredFlatbread": 9840,
	"./sugaredFlatbread.js": 9840,
	"./sugaredMashedBeans": 9744,
	"./sugaredMashedBeans.js": 9744,
	"./sweetBeanDonutHoles": 9897,
	"./sweetBeanDonutHoles.js": 9897,
	"./sweetBeanFlatbread": 5955,
	"./sweetBeanFlatbread.js": 5955,
	"./tallewFlatbread": 7338,
	"./tallewFlatbread.js": 7338,
	"./tastySnails": 9597,
	"./tastySnails.js": 9597,
	"./thaylenBread": 7887,
	"./thaylenBread.js": 7887,
	"./tsupales": 6319,
	"./tsupales.js": 6319,
	"./vegetableCurrySoup": 4307,
	"./vegetableCurrySoup.js": 4307,
	"./vegetablePancakes": 8931,
	"./vegetablePancakes.js": 8931,
	"./vegetablesWithBlackSauce": 9120,
	"./vegetablesWithBlackSauce.js": 9120
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4994;